import styled from 'styled-components';

import { H2, LabelRegular } from '@comeon/ui';

import Icon from '~/components/icon';

import { breakpointDesktop, DESKTOP_PRIMARY_SECTION_WIDTH } from './game-info.styles';

export const PrimarySection = styled.div`
	position: relative;
`;

export const BackgroundImageContainer = styled.div`
	position: absolute;
	z-index: 1;
	width: 100%;
	height: 100%;
	overflow: hidden;

	${breakpointDesktop} {
		border-radius: 12px 0 0 12px;
	}
`;

export const PrimarySectionContainer = styled.div<{ extraContent: boolean }>`
	display: grid;
	position: absolute;
	z-index: 3;
	width: 100%;
	height: 100%;

	grid-template-rows: 44px 204px 1fr;
	position: relative;

	backdrop-filter: blur(50px) brightness(75%);

	${breakpointDesktop} {
		grid-template-rows: 44px 204px 140px 64px;
	}
`;

// Header
export const HeaderSection = styled.div`
	position: relative;
	width: 100%;
	padding: 10px 12px;
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	justify-content: space-between;
`;

export const BackIcon = styled(Icon)<{ color: string }>`
	fill: ${({ color }) => color};
`;

export const ButtonContainer = styled.button`
	cursor: pointer;
	position: relative;
	display: inline-block;
	width: 24px;
	height: 24px;
	display: flex;
	justify-content: center;
	align-items: center;
`;

// Game name/provider
export const TitleSection = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: space-around;
	padding-block: 12px;

	${breakpointDesktop} {
		margin-block: auto;
	}
`;

export const GameName = styled(H2)`
	display: block;
	color: var(--game-info-name-text-color);
	text-align: center;
	padding-top: 6px;

	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	word-wrap: break-word;
	width: calc(100vw - 12px);

	${breakpointDesktop} {
		padding-top: 0;
		width: calc(${DESKTOP_PRIMARY_SECTION_WIDTH}px - 12px);
	}
`;

export const ProviderName = styled(LabelRegular)`
	display: block;
	color: var(--game-info-provider-text-color);
	padding-bottom: 6px;
	text-transform: none;
	cursor: pointer;

	${breakpointDesktop} {
		padding-bottom: 0;
	}
`;
